//onload script

try{
  /*
  function replaceLanguage(){
    if(langify && langify.helper){
      var ly_language = langify.helper.getSelectedLanguage();
      if(ly_language == 'ly79263'){
        //chs language
        setTimeout(function(){
          //replace buy button language
          buyItNowButtonArr = document.getElementsByClassName('shopify-payment-button__button');
          if(buyItNowButtonArr && buyItNowButtonArr[0]){
            buyItNowButtonText = buyItNowButtonArr[0].innerText;
            needReplaceText = 'buy it now';
            replaceText = '立即购买';
            if(buyItNowButtonText && buyItNowButtonText.toLowerCase().indexOf(needReplaceText) !== -1){
              replacedText = buyItNowButtonText.toLowerCase().replace(needReplaceText, replaceText);
              document.getElementsByClassName('shopify-payment-button__button')[0].innerText = replacedText;
              document.getElementsByClassName('shopify-payment-button__button')[0].onclick = function(){
              	document.getElementsByClassName('shopify-payment-button__button')[0].innerText = replacedText;
              };
              
            }
          }
        }, 6000);
      }else if(ly_language == 'ly79269'){
        //cht language
        setTimeout(function(){
          //replace buy button language
          buyItNowButtonArr = document.getElementsByClassName('shopify-payment-button__button');
          if(buyItNowButtonArr && buyItNowButtonArr[0]){
            buyItNowButtonText = buyItNowButtonArr[0].innerText;
            needReplaceText = 'buy it now';
            replaceText = '立即購買';
            if(buyItNowButtonText && buyItNowButtonText.toLowerCase().indexOf(needReplaceText) !== -1){
              replacedText = buyItNowButtonText.toLowerCase().replace(needReplaceText, replaceText);
              document.getElementsByClassName('shopify-payment-button__button')[0].innerText = replacedText;
              document.getElementsByClassName('shopify-payment-button__button')[0].onclick = function(){
              	document.getElementsByClassName('shopify-payment-button__button')[0].innerText = replacedText;
              };
            }
          }
        }, 6000);
      }
    }
  }
  */

  function initAfterOnload(){
    //replaceLanguage();
  }

  window.onload = function(){
    initAfterOnload();
  }
}catch(e){}
